module.exports = __webpack_public_path__ + "static/media/ConcaSwimlane.75768dd0.png";